// @flow
'use strict';

import * as React from 'react';

import type { IRecebedor } from '../types';
import { tipoDocumento } from './abas_informacoes';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

type RecebedorProps = {
  recebedor : IRecebedor,
};

export default function Recebedor({ recebedor } : RecebedorProps) {
  if (!recebedor)
    return <h4 className="text-center" style={ { fontStyle: 'italic' } }>Nenhum recebedor informado no CT-e.</h4>

  return (
      <div className="tab-pane active">
        <h3>Recebedor</h3>
        <RowDetalhes data={ recebedor } className="no-margin-bottom">
          <ColumnDetalhes field="cnpj" type="documento" width="50%">{ tipoDocumento(recebedor) }</ColumnDetalhes>
          <ColumnDetalhes field="ie" width="50%">Inscrição Estadual</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ recebedor } className="no-margin-bottom">
          <ColumnDetalhes field="nomeRazaoSocial" width="50%">Nome / Razão Social</ColumnDetalhes>
          <ColumnDetalhes field="telefone" width="50%">Telefone</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ recebedor } className="no-margin-bottom">
          <ColumnDetalhes field="endereco" width="50%">Endereço</ColumnDetalhes>
          <ColumnDetalhes field="bairro" width="50%">Bairro</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ recebedor } className="no-margin-bottom">
          <ColumnDetalhes field="municipio" width="50%">Município</ColumnDetalhes>
          <ColumnDetalhes field="cep" type="cep" width="50%">CEP</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ recebedor } className="no-margin-bottom">
          <ColumnDetalhes field="uf" width="50%">UF</ColumnDetalhes>
          <ColumnDetalhes field="pais" width="50%">País</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ recebedor }>
          <ColumnDetalhes field="email" width="50%">E-mail</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}
